// import $ from '../../../vendor/js/jquery';
import style from './style.scss';
import '../../../vendor/js/magiczoom.js';
import '../../../vendor/style/magiczoom.css';

export default function ($scope, $rootScope, $timeout, $http, $state, $sce, $filter) {
    'ngInject';
    $scope.style = style;

    var idProduct = $state.params.id.split('-')[0],
        configProduto;

    configProduto = function (product) {
        if (product) {
            product = $rootScope.configProduto(product);
            product.descricao = $sce.trustAsHtml(product.descricao);
            product.imagesArray = Object.keys(product.imagens)
                .splice(0, Object.keys(product.imagens).length - 1)
                .map(index => product.imagens[index])
                .map(image => Object.assign(image, { 
                    image300: image.imageDone = `${$rootScope.backURL}/lib.data/produtos/${$filter('resizeImage')(image.imagem, 300, 300)}`,
                    image100: image.imageDone = `${$rootScope.backURL}/lib.data/produtos/${$filter('resizeImage')(image.imagem, 100, 100)}`
                }));

            if (product.categorias && product.categorias.length > 0) {
                $http.get($scope.backURL + 'api/categorias/' + product.categorias[0].id + '/produtos', {
                    params: {
                        offset: 0,
                        limit: 8,
                        disponivel: 1,
                        promocao: 1
                    }
                }).then(data => {
                    $scope.categorias = data.data.data.result || [];
                    $scope.categorias = $scope.categorias.splice(0, 4);
                });
            }
            $timeout(() => window.MagicZoom.start('detail'), 500);
        }

        return product;
    };

    $scope.product = configProduto($rootScope.produto);
    $scope.categorias = [];

    $http.get($scope.backURL + 'api/produtos/' + idProduct).then(function (data) {
        $scope.product = configProduto(data.data.data);
    });
}



// WEBPACK FOOTER //
// ./src/app/views/app.detail/index.js